/**
 * @fileoverview Minimal spinner shared across the UI.
 *
 * @purpose Provide a small reusable spinner with configurable size.
 * @usage Used inside loading overlays, toasts, and skeletons.
 * @ownership Shared UI components (core)
 * @dependencies
 * - react
 * - @/core/lib/utils (cn helper)
 * @restrictions
 * - DO NOT embed fetch logic; this only renders a spinner.
 */
import { cn } from '../../lib/utils';

type LoadingSpinnerProps = {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function LoadingSpinner({ size = 'md', className }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  }

  return (
    <div
      className={cn(
        'animate-spin rounded-full border-2 border-current border-t-transparent',
        sizeClasses[size],
        className
      )}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  )
}







